
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import WhyCabil from "../../components/root/WhyCabil";
import HowItWorks from "../../components/root/HowItWorks";
import HumanExpertise from "../../components/root/HumanExpertise";
import Testimonials from "../../components/root/Testimonials";
import img1 from "../../assets/new images/students.png";
import img2 from "../../assets/new images/graduates.png";
import img3 from "../../assets/new images/professional.png";
import backgroundImage from "../../assets/new images/Background.png";
import Features from "../../components/root/Features";
import AiCareerSection from "../../components/root/AiCareerSection";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
const AiCareer = () => {
   const { t } = useTranslation();
   // NOTE: pre-existing typos in original English copy ("tracks,internships" missing space, "strategi" -> "strategic") preserved verbatim in translation keys to avoid changing displayed text.
   const steps = [
  {
    img: img1,
    title: t("aiCareer.steps.students.title"),
    desc: t("aiCareer.steps.students.desc"),
  },
  {
    img: img2,
    title: t("aiCareer.steps.graduates.title"),
    desc: t("aiCareer.steps.graduates.desc"),
  },
  {
    img: img3,
    title: t("aiCareer.steps.professionals.title"),
    desc: t("aiCareer.steps.professionals.desc"),
  },
];
    return (
    <div className="font-sans overflow-x-hidden">
      <Seo
        {...SEO["/ai-career"]}
        path="/ai-career"
      />

      <Hero bgImage={backgroundImage}
        badgeText={`✨ ${t("hero.badge")}`}
        titleLines={[t("aiCareer.heroTitle1"), t("aiCareer.heroTitle2")]}
        subtitle={t("aiCareer.heroSubtitle")}
        primary={{ label: t("hero.findMentor"), href: "/mentors" }}
        secondary={{ label: t("hero.tryAi"), href: "/ai-career" }}
        curveColor="#F9FAFB"     // match the next section's background (e.g., Tailwind bg-gray-50)
        heightClass="h-[100vh] min-h-[560px]"
        overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
        roundedButtons={true} />

<Features/>
      <HowItWorks
         title={t("aiCareer.howItWorksTitle")}
         subtitle={t("howItWorks.subtitle")}
         steps={steps}
         accentColor="#EE5F2B"  // matches your brand orange
       />
<AiCareerSection/>
  

    </div>
  );
};

export default AiCareer;
